import { render, staticRenderFns } from "./ProposalInfo.vue?vue&type=template&id=40cda2a6&scoped=true"
import script from "./ProposalInfo.vue?vue&type=script&lang=js"
export * from "./ProposalInfo.vue?vue&type=script&lang=js"
import style0 from "./ProposalInfo.vue?vue&type=style&index=0&id=40cda2a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cda2a6",
  null
  
)

export default component.exports